import { ItemCarrinho } from '../delivery.types';

const TTL_MS = 30 * 60 * 1000; // 30 minutos

export interface CachePedido {
  carrinho: ItemCarrinho[];
  step: number;
  nomeContato: string;
  whatsappContato: string;
  tipoRetirada: 'ENTREGA' | 'RETIRADA';
  codigoTipoTitulo: number | null;
  observacaoGeral: string;
  expiresAt: number;
}

function chave(tenant: string, codigoUnidade: number): string {
  return `delivery_pedido_${tenant}_${codigoUnidade}`;
}

export function salvarCache(tenant: string, codigoUnidade: number, dados: Omit<CachePedido, 'expiresAt'>): void {
  try {
    const payload: CachePedido = { ...dados, expiresAt: Date.now() + TTL_MS };
    localStorage.setItem(chave(tenant, codigoUnidade), JSON.stringify(payload));
  } catch {
    // localStorage pode estar cheio ou indisponível — ignora silenciosamente
  }
}

export function carregarCache(tenant: string, codigoUnidade: number): CachePedido | null {
  try {
    const raw = localStorage.getItem(chave(tenant, codigoUnidade));
    if (!raw) return null;
    const dados: CachePedido = JSON.parse(raw);
    if (Date.now() > dados.expiresAt) {
      localStorage.removeItem(chave(tenant, codigoUnidade));
      return null;
    }
    return dados;
  } catch {
    return null;
  }
}

export function limparCache(tenant: string, codigoUnidade: number): void {
  try {
    localStorage.removeItem(chave(tenant, codigoUnidade));
  } catch {
    // ignora
  }
}
